import Chart from "react-apexcharts";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const DistributionChart = ({ rightChartData }) => {
  const { t } = useTranslation();
  const [chartData, setChartData] = useState({
    series: [],
    labels: [],
    colors: [],
  });

  useEffect(() => {
    if (rightChartData && Array.isArray(rightChartData)) {
      // Extract values, labels, and colors from the backend data
      const series = rightChartData
        ?.filter((el) => el.value !== 0)
        ?.map((item) => item.value);
      const labels = rightChartData
        ?.filter((el) => el.value !== 0)
        ?.map((item) => item.region);
      const colors = rightChartData
        ?.filter((el) => el.value !== 0)
        ?.map((item) => item.colour);

      setChartData({ series, labels, colors });
    }
  }, [rightChartData]);

  const donutChartOptions = {
    chart: {
      type: "pie",
    },
    labels: chartData.labels,
    colors: chartData.colors,
    legend: {
      position: "bottom", // Default legend position
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            // width: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div className="_card">
      <div className="survey_chart">
        <h3>
          <span>{t("SURVEY_ANALYSIS.distributeRegion")}</span>
          {/* <select>
            <option>Riyadh</option>
          </select> */}
        </h3>
        <div className="chart">
          <Chart
            type="pie"
            series={chartData.series}
            options={donutChartOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default DistributionChart;
